/* eslint-disable prettier/prettier */
import React, { useEffect, useMemo, useState } from 'react';
import styles from './AttendanceModal.module.css';
import edit from '../../../../assets/coach/Edit (1).png';
import calander from '../../../../assets/coach/cl.png';
import timee from '../../../../assets/coach/time.png';
import fallbackProfile from '../../../../assets/profile/fallback.png';


export interface Participant {
	id: string;

	userid?: string;

	name: string;

	avatar?: string;

	status?: 'present' | 'absent' | 'late' | 'excused' | null;
}
interface AttendanceModalProps {
	open: boolean;
	title: string;
	activityType: string;
	activityTypeColor?: string;
	date: string;
	time: string;
	programName: string;
	masterclassTitle: string;
	description: string;
	participants: Participant[];
	onClose: () => void;
	onSave?: (participants: Participant[]) => void;
	onEdit?: () => void;
	attendanceAlreadyMarked?: boolean;
}

const AttendanceModal: React.FC<AttendanceModalProps> = ({
	open,
	title,
	activityType,
	activityTypeColor,
	date,
	time,
	programName,
	masterclassTitle,
	description,
	participants,
	onClose,
	onSave,
	onEdit,
	attendanceAlreadyMarked = false,
}) => {
	const [selectedIds, setSelectedIds] = useState<string[]>([]);
	const [isSubmitted, setIsSubmitted] = useState(false);
	const [updatedParticipants, setUpdatedParticipants] =
		useState<Participant[]>(participants);

	useEffect(() => {
		setUpdatedParticipants(participants);
	}, [participants]);

	const allSelected = useMemo(() => {
		return (
			updatedParticipants.length > 0 &&
			selectedIds.length === updatedParticipants.length
		);
	}, [selectedIds, updatedParticipants]);

	const handleSelect = (id: string) => {
		setSelectedIds(prev =>
			prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
		);
	};

	const handleClose = () => {
		setIsSubmitted(false);
		setSelectedIds([]);
		onClose();
	};

	const handleSelectAll = () => {
		if (allSelected) {
			setSelectedIds([]);
		} else {
			setSelectedIds(updatedParticipants.map(item => item.id));
		}
	};

	//     const updateAttendance = (type: 'present' | 'absent') => {
	//     const updated = updatedParticipants.map(item => ({
	//         ...item,
	//         status: selectedIds.includes(item.id)
	//             ? type
	//             : type === 'present'
	//               ? 'absent'
	//               : 'present',
	//     }));

	//     setUpdatedParticipants(updated);
	//     setSelectedIds([]);

	//     // hide checkboxes + show edit button
	//     setIsSubmitted(true);

	//     onSave?.(updated);
	// };
	const updateAttendance = (type: 'present' | 'absent') => {
		let updated: Participant[];

		if (!attendanceAlreadyMarked) {
			// First attendance marking

			updated = updatedParticipants.map(item => ({
				...item,
				status: selectedIds.includes(item.id)
					? type
					: type === 'present'
						? 'absent'
						: 'present',
			}));
		} else {
			// Edit mode
			// Change only selected users

			updated = updatedParticipants.map(item => {
				if (selectedIds.includes(item.id)) {
					return {
						...item,
						status: type,
					};
				}

				return item;
			});
		}

		setUpdatedParticipants(updated);
		setSelectedIds([]);
		setIsSubmitted(true);

		onSave?.(updated);
	};

	if (!open) return null;

	return (
		<div className={styles.overlay}>
			<div className={styles.modal}>
				{/* Header */}
				<div className={styles.topSection}>
					<div className={styles.badge}>
						{/* <span className={styles.badgeDot} /> */}
						<span
							className={styles.badgeDot}
							style={{
								backgroundColor: activityTypeColor || '#EF4444',
							}}
						/>
						{activityType}
					</div>

					<div className={styles.actions}>
						{isSubmitted && (
							<button
								className={styles.iconBtn}
								onClick={() => {
									setIsSubmitted(false);
									onEdit?.();
								}}
							>
								<img
									src={edit}
									alt="edit"
									className={styles.actionIcon}
								/>
							</button>
						)}

						<button
							className={styles.closeBtn}
							// onClick={onClose}
							onClick={handleClose}
						>
							✕
						</button>
					</div>
				</div>

				{/* Title */}
				<h2 className={styles.title}>{title}</h2>

				{/* Meta */}
				<div className={styles.meta}>
					<div className={styles.metaItem}>
						<img
							src={calander}
							alt="calendar"
							className={styles.metaIcon}
						/>

						<span>{date}</span>
					</div>

					<div className={styles.metaItem}>
						<img
							src={timee}
							alt="time"
							className={styles.metaIcon}
						/>

						<span>{time}</span>
					</div>
				</div>

				{/* Info */}
				<div className={styles.infoSection}>
					<div className={styles.infoRow}>
						<p className={styles.label}>Program Name</p>
						<p className={styles.value}>{programName}</p>
					</div>

					<div className={styles.infoRow}>
						<p className={styles.label}>Masterclass/Session</p>
						<p className={styles.value}>{masterclassTitle}</p>
					</div>
				</div>

				{/* Description */}
				<div className={styles.descriptionSection}>
					<p className={styles.sectionTitle}>Activity Description</p>

					<p className={styles.description}>{description}</p>
				</div>

				{/* Attendance */}
				<div className={styles.attendanceSection}>
					<div className={styles.attendanceHeader}>
						<p className={styles.sectionTitle}>
							Participants Attendance
						</p>

						<span className={styles.count}>
							{updatedParticipants.length} Participants
						</span>
					</div>

					<div className={styles.participantsWrapper}>
						{updatedParticipants.map(item => (
							<div
								key={item.id}
								className={styles.participantRow}
							>
								<div className={styles.left}>
									{!isSubmitted && (
										<input
											className={styles.checkbox}
											type="checkbox"
											checked={selectedIds.includes(
												item.id
											)}
											onChange={() =>
												handleSelect(item.id)
											}
										/>
									)}

									<div className={styles.avatar}>
  <img
    src={item.avatar || fallbackProfile}
    alt={item.name}
    onError={(e) => {
      e.currentTarget.src = fallbackProfile;
    }}
  />
</div>

									<p className={styles.name}>{item.name}</p>
								</div>

								{item.status && (
									<span
										className={`${styles.status} ${
											item.status === 'present'
												? styles.present
												: styles.absent
										}`}
									>
										{item.status}
									</span>
								)}
							</div>
						))}
					</div>

					{/* Footer */}
					<div className={styles.footer}>
						{!isSubmitted && (
							<label className={styles.selectAll}>
								<input
									className={styles.checkbox}
									type="checkbox"
									checked={allSelected}
									onChange={handleSelectAll}
								/>
								Select All
							</label>
						)}

						{/* <div className={styles.footerBtns}> */}
						{!isSubmitted && (
							<div className={styles.footerBtns}>
								<button
									className={styles.presentBtn}
									onClick={() => updateAttendance('present')}
								>
									Present
								</button>

								<button
									className={styles.absentBtn}
									onClick={() => updateAttendance('absent')}
								>
									Absent
								</button>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default AttendanceModal;
